import { render, staticRenderFns } from "./JourneyBuilder.vue?vue&type=template&id=10e03ad0&scoped=true&"
import script from "./JourneyBuilder.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilder.vue?vue&type=script&lang=js&"
import style0 from "./JourneyBuilder.vue?vue&type=style&index=0&id=10e03ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e03ad0",
  null
  
)

export default component.exports